export default {
  title: '邮编管理',

  tabs: {
    china: '中国',
    us: '美国'
  },

  search: {
    keyword: '关键词搜索',
    keywordPlaceholderChina: '邮编, 市, 区域名称',
    keywordPlaceholderUS: '邮编, 城市, 区域名称',
    administrativeDivision: '行政区划',
    selectProvince: '请选择省',
    state: '州',
    allStates: '全部州',
    status: '状态',
    statusPlaceholder: '选择状态',
    allStatus: '全部状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  actions: {
    addChinaZipcode: '新增中国邮编',
    addUSZipcode: '新增美国邮编',
    recordsCount: '共 {count} 条记录',
    edit: '编辑',
    enable: '启用',
    disable: '禁用',
    batchEnable: '批量启用',
    batchDisable: '批量禁用'
  },

  table: {
    postalCode: '邮编',
    province: '省',
    city: '市',
    district: '区/县',
    street: '街道/乡镇',
    areaName: '区域名称',
    state: '州',
    status: '状态',
    operation: '操作'
  },

  form: {
    addTitle: '新增邮编',
    editTitle: '编辑邮编',
    postalCode: '邮政编码',
    postalCodePlaceholder: '请输入邮政编码',
    administrativeDivision: '行政区划',
    selectAdministrativeDivision: '请选择省/市/区县/街道',
    stateCity: '州-市选择',
    selectStateCity: '请选择州和城市',
    areaName: '区域名称',
    areaNamePlaceholder: '请输入具体区域名称（可选）',
    areaNameCn: '区域名称（中文）',
    areaNameCnPlaceholder: '请输入区域中文名称（可选）',
    status: '状态',
    statusPlaceholder: '请选择状态'
  },

  modal: {
    addTitle: '新增邮编',
    editTitle: '编辑邮编'
  },

  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  validation: {
    postalCodeRequired: '请输入邮政编码',
    statusRequired: '请选择状态',
    administrativeDivisionRequired: '请至少选择到区/县级行政区划',
    stateCityRequired: '请选择州和城市',
    stateRequired: '请选择州',
    cityRequired: '请选择城市'
  },

  messages: {
    checkRequired: '请检查必填字段',
    saveSuccess: '保存成功',
    updateSuccess: '更新成功',
    saveError: '保存失败',
    loadError: '加载邮编数据失败',
    loadAdministrativeDivisionError: '加载中国行政区划数据失败',
    loadUSAdministrativeDivisionError: '加载美国行政区划数据失败',
    loadUSStatesError: '加载美国州数据失败',
    loadUSCitiesError: '加载{state}城市数据失败',
    statusToggleSuccess: '{action}成功',
    statusToggleError: '{action}失败',
    selectToEnable: '请选择要启用的邮编',
    selectToDisable: '请选择要禁用的邮编',
    batchEnableSuccess: '批量启用成功',
    batchEnableError: '批量启用失败',
    batchDisableSuccess: '批量禁用成功',
    batchDisableError: '批量禁用失败'
  },

  confirm: {
    toggleStatus: '确定要{action}此邮编吗？',
    toggleStatusContent: '邮编：{postalCode}',
    batchEnable: '批量启用确认',
    batchEnableContent: '确定要启用选中的 {count} 条邮编吗？',
    batchDisable: '批量禁用确认',
    batchDisableContent: '确定要禁用选中的 {count} 条邮编吗？'
  }
}